import BigNumber from 'bignumber.js'
import React from 'react'
import EntryTime from '../../PositionColumns/EntryTime'
import KrwPrice from '../../PositionColumns/KrwPrice'
import { cell_user_nolive } from '../Cell/user'

export const column_balance_daily = (mutate, showModal) => {
	return [
		{
			title: '그룹',
			dataIndex: 'referral_code',
			key: 'referral_code',
			align: 'center',
			width: 100,
		},
		{
			title: '아이디',
			dataIndex: 'loginid',
			key: 'loginid',
			align: 'center',
		},
		{
			title: '실명',
			dataIndex: 'fullname',
			key: 'fullname',
		},
		//cell_user_nolive(mutate, showModal, 'id'), //회원
		{
			title: '날짜',
			dataIndex: 'daydate',
			key: 'daydate',
			align: 'center',
			width: 80,
			render: (text, data) => {
				return <EntryTime time={text} format={'YYYY-MM-DD'} />
			},
		},
		{
			title: '입금총액',
			align: 'center',
			children: [
				{
					title: '일반입금',
					dataIndex: 'total_deposit_amount',
					key: 'total_deposit_amount',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '별도입금',
					dataIndex: 'total_deposit_amount_extra',
					key: 'total_deposit_amount_extra',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '코인>해선',
					dataIndex: 'total_deposit_amount_move',
					key: 'total_deposit_amount_move',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
			],
		},
		{
			title: '출금총액',
			align: 'center',
			children: [
				{
					title: '일반출금',
					dataIndex: 'total_withdraw_amount',
					key: 'total_withdraw_amount',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '별도출금',
					dataIndex: 'total_withdraw_amount_extra',
					key: 'total_withdraw_amount_extra',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '해선>코인',
					dataIndex: 'total_withdraw_amount_move',
					key: 'total_withdraw_amount_moove',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
				},
			],
		},
		{
			title: '손익현황',
			align: 'center',
			children: [
				{
					title: '총매매손익',
					dataIndex: 'total_pnl_price',
					key: 'total_pnl_price',
					align: 'center',
					width: 130,
					rowScope: 'row',
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '수수료',
					dataIndex: 'total_fee_price',
					key: 'total_fee_price',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '실현손익',
					dataIndex: 'total_trade_price',
					key: 'total_trade_price',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return (
							<div
								className={
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') + ' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
			],
		},
		{
			title: '마지막잔액',
			align: 'center',
			children: [
				{
					title: '예수금',
					dataIndex: 'last_balance',
					key: 'last_balance',
					align: 'center',
					width: 130,
					render: (text, data) => {
						return <KrwPrice price={Math.abs(text)} dp={0} />
					},
				},
			],
		},
	]
}
